import React from "react"
import { Box } from "@mui/material"

export type CalculatorPlatform = "amazon" | "meesho"

const PLATFORM_LOGOS: Record<CalculatorPlatform, { src: string; alt: string }> = {
  amazon: {
    src: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg",
    alt: "Amazon"
  },
  meesho: {
    src: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Meesho_logo.png/250px-Meesho_logo.png",
    alt: "Meesho"
  }
}

interface PlatformIconProps {
  platform: CalculatorPlatform
}

const PlatformIcon: React.FC<PlatformIconProps> = ({ platform }) => {
  const logo = PLATFORM_LOGOS[platform]

  return (
    <Box
      sx={{
        width: 40,
        height: 40,
        px: 0.75,
        borderRadius: 2,
        bgcolor: "common.white",
        border: "1px solid",
        borderColor: platform === "amazon" ? "#FF9900" : "#9F2089",
        boxShadow: "0 2px 8px rgba(15, 23, 42, 0.08)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
      <Box
        component="img"
        src={logo.src}
        alt={`${logo.alt} logo`}
        sx={{ width: "100%", maxHeight: 24, objectFit: "contain", display: "block" }}
      />
    </Box>
  )
}

export default PlatformIcon
